import { createBrowserRouter } from 'react-router-dom';

import App from './App';

// Pages
import { HomePage, CalculatorPage, TarifePage } from './pages';

const Router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '/',
        element: <HomePage />,
      },
      {
        path: 'tarife',
        element: <TarifePage />,
      },
      {
        path: 'calculator',
        element: <CalculatorPage />,
      }
    ],
  },

]);

export default Router;